module.exports = __webpack_public_path__ + "img/jacket.ff55736c.png";